import { Skeleton } from "@/atoms"
import { LoadErrorEmptyTable } from "@/molecules/EmptyTable"
import { useAgentPlatformConnections } from "@/pages/DeploymentsPage/application/useAgentPlatform"
import { CloudConnectionUnavailable } from "@/pages/DeploymentsPage/components/molecules/CloudConnectionStatus"
import { DeployTab } from "@/pages/DeploymentsPage/components/molecules/DeployTab"
import { CopilotStudioSetup } from "./CopilotStudioSetup"

// The agentless connections of the Microsoft tenants: Kodem discovers each
// tenant's Copilot Studio agents and, with runtime protection, decides their
// tool calls. Every tenant is connected with these steps; the connected ones
// are on the deployments list, their settings at the end of their rows.
export const CopilotStudioConnection = () => {
  const { isLoading, isLoadError, isUnavailable, refetch } =
    useAgentPlatformConnections("copilot-studio")

  // Not a step of the user's: the state of the connection itself
  const state = (content: React.ReactNode) => (
    <DeployTab steps={[]} hideReadMoreLink>
      {content}
    </DeployTab>
  )

  if (isLoading) return state(<Skeleton active paragraph={{ rows: 4 }} />)

  if (isLoadError) return state(<LoadErrorEmptyTable onRetry={refetch} />)

  if (isUnavailable) return state(<CloudConnectionUnavailable />)

  return <CopilotStudioSetup />
}
